import request from '@/router/axios';

export const getRegionList = () => {
    return request({
        url: '/api/blade-system/region/auth-tree-region',
        method: 'get'
    })
}

export const roleMobileMenu = () => {
  return request({
    url: 'api/blade-system/menu/role-mobile-menu',
    method: 'get'
  })
}
export const getServerIP = (tmId) => {
  return request({
    url: '/counter/control/blade-control/server/get-server-ip',
    method: 'get',
    params: {
      tmId: tmId
    }
  })
};

export const setServer=(param,serverNo)=>{
  return request({
    url: '/counter/control/blade-control/heartbeat/set-server',
    method: 'post',
    params: {
      ...param,
      serverNo: serverNo
    }
  });
}

export const startServerMobile = (tmid, serverNo) => {
  return request({
    url: '/counter/control/blade-control/heartbeat/open-server',
    method: 'post',
    params: {
      tmid: tmid,
      serverNo: serverNo
    }
  })
};

export const closeServerMobile = (tmid, serverNo) => {
  return request({
    url: '/counter/control/blade-control/heartbeat/close-server',
    method: 'post',
    params: {
      tmid: tmid,
      serverNo: serverNo
    }
  })
};
export const getHeartByTmId = (tmId) => {
  return request({
    url: '/counter/control/blade-control/heartbeat/get-heart-by-tm-id',
    method: 'get',
    params: {
      tmId: tmId
    }
  })
};



// WEBPACK FOOTER //
// ./src/api/region.js